/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const appCardListPayoutConfig = {
  logo: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.images/fhp-favicon.png',
  appCardList: [
    {
      appCardId: '1',
      appCardImage:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ89w_hKqPNliwilK5T36RXv33yELO3wA8SQQ&usqp=CAU',
      appCardTitle: 'Payout-1',
      appCardDescription: 'Id:12345678',
      ribbon: {
        title: 'New',
        backgroundColor: '#5f5',
      },
    },
    {
      appCardId: '2',
      appCardTitle: 'Payout-2',
      appCardDescription: 'Id:12345678',
      appCardImage:
        'https://cdn.w600.comps.canstockphoto.com/payout-red-stamp-text-clip-art-vector_csp21187167.jpg',
      ribbon: {
        title: 'Closed',
        backgroundColor: '#b00',
      },
    },
    {
      appCardId: '3',
      appCardTitle: 'Payout-3',
      appCardDescription: 'Id:12345678',
      appCardImage:
        'https://thumbs.dreamstime.com/z/payout-button-flat-icon-hand-pay-color-icons-trendy-style-payment-gradient-design-designed-web-app-eps-141843760.jpg',
    },
    {
      appCardId: '4',
      appCardTitle: 'Payout-4',
      appCardDescription: 'Id:12345678',
      appCardImage: 'https://www.bsevaonline.co.in/images/payout.jpg',
    },
    {
      appCardId: '5',
      appCardTitle: 'Payout-5',
      appCardDescription: 'Id:12345678',
      appCardImage:
        'https://cdn1.vectorstock.com/i/1000x1000/49/15/payout-rubber-stamp-vector-13344915.jpg',
    },
    {
      appCardId: '6',
      appCardTitle: 'Payout-6',
      appCardDescription: 'Id:12345678',
      appCardImage:
        'https://www.shutterstock.com/image-vector/money-transfer-vector-icon-isolated-260nw-1196161159.jpg',
    },
  ],
  activePage: 1,
  pageSize: 10,
  totalCount: 6,
  totalPages: 1,
};
